import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-product-type-field',
  templateUrl: './product-type-field.component.html',
  styleUrls: ['./product-type-field.component.scss']
})
export class ProductTypeFieldComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
